
import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { motion } from 'framer-motion';

interface NotificationFooterProps {
  realtimeStatus: 'connected' | 'disconnected' | 'error';
  lastUpdateTime: Date | null;
  reconnect: () => void;
  toast: any;
}

export const NotificationFooter: React.FC<NotificationFooterProps> = ({
  realtimeStatus,
  lastUpdateTime,
  reconnect,
  toast
}) => {
  // Format time since last update
  const getLastUpdateText = () => {
    if (!lastUpdateTime) return "Never updated";
    return `Last updated ${formatDistanceToNow(lastUpdateTime, { addSuffix: true })}`;
  };

  if (realtimeStatus === 'error') {
    return (
      <motion.div 
        className="p-3 bg-destructive/10 text-xs text-center border-t"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <p className="text-destructive">
          Notification updates may be delayed. 
          <button 
            className="ml-1 underline font-medium hover:text-destructive/80 transition-colors" 
            onClick={() => {
              reconnect();
              toast({
                title: "Refreshing",
                description: "Manually refreshing notifications",
              });
            }}
          >
            Refresh
          </button>
        </p>
      </motion.div>
    );
  }

  return (
    <div className="p-2 text-xs text-center text-muted-foreground border-t">
      {getLastUpdateText()}
    </div>
  );
};
